'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkResponse = checkResponse;
exports.callFetch = callFetch;

var _serviceHttpResponseError = require('./serviceHttpResponseError');

var _serviceHttpResponseError2 = _interopRequireDefault(_serviceHttpResponseError);

var _endpoints = require('./endpoints.js');

var _endpoints2 = _interopRequireDefault(_endpoints);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function checkResponse(serviceEndpoint) {
  return function (res) {
    if (res.ok) {
      return res.json();
    } else {
      throw new _serviceHttpResponseError2.default('Error calling ' + serviceEndpoint + ' endpoint', res);
    }
  };
}

function callFetch(endpointKey, method, route, body, accessToken, env) {
  var endpointUrl = (_endpoints2.default[env] || _endpoints2.default['prd'])[endpointKey];
  var headers = new Headers({
    Accept: 'application/json',
    Authorization: 'Bearer ' + accessToken
  });
  method = method ? method.toUpperCase() : 'GET';

  if (method === 'POST' || method === 'PUT' || method === 'PATCH') {
    headers.append('Content-Type', 'application/json');
  }

  var options = {
    method: method,
    mode: 'cors',
    headers: headers,
    body: body
  };
  var fullUrl = route ? endpointUrl + '/' + route : endpointUrl;
  return fetch(fullUrl, options).then(checkResponse(method + ' ' + fullUrl));
}